import React from "react";
import { cn } from "utils";

export interface StatSectionProps {
  /** 标题 */
  title: string;
  /** 左侧内容 */
  leftContent: React.ReactNode;
  /** 右侧内容 */
  rightContent?: React.ReactNode;
  /** 自定义类名 */
  className?: string;
  /** 是否显示加载状态 */
  isLoading?: boolean;
}

/**
 * 骨架屏组件
 */
const SkeletonContent: React.FC = () => {
  return (
    <>
      {/* 左侧骨架屏 */}
      <div className="flex flex-col gap-2 flex-1 min-w-0">
        {/* 第一行 - 较长 */}
        <div className="h-4 bg-background_white_overlay10 rounded animate-pulse w-1/5" />
        {/* 第二行 - 较短 */}
        <div className="h-5 bg-background_white_overlay10 rounded animate-pulse w-1/3" />
      </div>
    </>
  );
};

/**
 * 统计区块组件
 * 统一的统计项布局结构，包含标题、左侧内容和右侧内容
 */
export const StatSection: React.FC<StatSectionProps> = ({
  title,
  leftContent,
  rightContent,
  className,
  isLoading = false,
}) => {
  if (isLoading) {
    return <SkeletonContent />;
  }
  return (
    <div
      className={cn(
        "flex flex-col gap-0.5 items-start min-w-0 flex-1",
        className,
      )}
    >
      {/* 标题 */}
      <p className="body_medium_s text-content_tertiary truncate w-full">
        {title}
      </p>

      {/* 内容区域 */}
      <div className="flex gap-1 items-center min-w-0 w-full">
        {/* 左侧内容 */}
        <div className="flex items-center min-w-0 max-md:flex-none">
          {leftContent}
        </div>

        {/* 右侧内容 */}
        {rightContent && <div className="shrink-0">{rightContent}</div>}
      </div>
    </div>
  );
};
